export class SelectableClient {
  public ClientID: number;
  public ClientCode: string;
  public ClientShortName: string;
  public Lang: string;
  public RDOAccess: boolean;
  public RDOCustomGridsEditor: boolean;
  public RDOClientCustomGridsEditor: boolean;
  public RDODownloads: boolean;
  public HasGeographyFullAccess: boolean;
  public HasSalesRepRole: boolean;
  public HasCustomGridsData: boolean;
  public AvailableCustomGridSources: Array<string>;
  public HasCustomerSelection: boolean;
  public HasOperatedData: boolean;
  public MQAAccess: boolean;
  public ADMINAccess: boolean;
  public ADMINManageUsers: boolean;
  public MQARestricted: boolean;
  public DataLastUpdated: Date | null;
  public Identifier: any;
  public RequiresMQACompetitionDisclaimer: boolean;
  public MaxNumDaysInStatus: number;

  constructor(
    clientid: number = 0,
    clientcode: string = '',
    clientshortname: string = '',
    lang: string = '',
    rdoAccess: boolean = false,
    rdoDownloads: boolean = false,
    rdoCustomGridsEditor: boolean = false,
    rdoClientCustomGridsEditor: boolean = false,
    hasCustomGridsData: boolean = false,
    availableCustomGridSources: Array<string> = [],
    hasCustomerSelection: boolean = false,
    hasGeographyFullAccess: boolean = false,
    mqaAccess: boolean = false,
    adminAccess: boolean = false,
    adminManageUsers: boolean = false,
    mqaRestricted: boolean = false,
    hasSalesRepRole: boolean = false,
    dataLastUpdated: Date | null = null,
    hasOperatedData: boolean = false,
    requiresMQACompetitionDisclaimer: boolean = false,
    maxNumberDaysInStatus: number = 0
  ) {
    this.ClientID = clientid;
    this.ClientCode = clientcode;
    this.ClientShortName = clientshortname;
    this.Lang = lang;
    this.RDOAccess = rdoAccess;
    this.RDODownloads = rdoDownloads;
    this.RDOCustomGridsEditor = rdoCustomGridsEditor;
    this.RDOClientCustomGridsEditor = rdoClientCustomGridsEditor;
    this.HasGeographyFullAccess = hasGeographyFullAccess;
    this.HasSalesRepRole = hasSalesRepRole;
    this.HasCustomGridsData = hasCustomGridsData;
    this.AvailableCustomGridSources = availableCustomGridSources;
    this.HasCustomerSelection = hasCustomerSelection;
    this.MQAAccess = mqaAccess;
    this.ADMINAccess = adminAccess;
    this.ADMINManageUsers = adminManageUsers;
    this.MQARestricted = mqaRestricted;
    this.DataLastUpdated = dataLastUpdated;
    this.HasOperatedData = hasOperatedData;
    this.RequiresMQACompetitionDisclaimer = requiresMQACompetitionDisclaimer;
    this.MaxNumDaysInStatus = maxNumberDaysInStatus;
  }
}
